import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-verification-success',
  templateUrl: './email-verification-success.component.html',
  styleUrls: ['./email-verification-success.component.scss']
})
export class EmailVerificationSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
